import styled from 'styled-components';

export const Item = styled.div`
  &.sortable-ghost {
    background-color: #bee3f8;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    z-index: 10;
  }
`;